'use client';

interface InputFieldProps {
  items?: string;
  id: string;
  type?: string;
  classname?: string;
  htmlFor?: string;
  value?: string;
  disabled?: boolean;
  label?: string;
  errors?: any;
  onChange?: any;
  maxLength?: number;
  hideError?: boolean;
}

const AdjustAmountField: React.FC<InputFieldProps> = ({
  items,
  id,
  htmlFor,
  classname,
  value,
  errors,
  maxLength,
  onChange,
}) => {
  return (
    <div className={`relative w-full`}>
      <input
        id={id}
        className={
          'peer block appearance-none rounded-lg border bg-transparent p-4 pr-[2.5rem] text-base text-black ' +
          (errors?.[id] ? ' border-2 border-scarletRed ' : ' border-foggyGray ') +
          classname
        }
        value={value}
        maxLength={maxLength}
        onChange={onChange}
        placeholder=""
      />
      <label
        htmlFor={htmlFor}
        className={
          'absolute start-1 top-1 ml-1 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-base duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4' +
          (errors?.[id] && ' text-scarletRed ')
        }
      >
        {items}
      </label>
    </div>
  );
};

export default AdjustAmountField;
